<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/g0pPEC/tc-custom/9781504041515.jpg?1734211352475" alt="This image is the cover for the book Fire Lover"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fire Lover
      </h1>
      <p class="bookDescription body article font2">
        <b>The hunt for</b><b>the most prolific American arsonist of the twentieth century</b><b>—</b><b>in this Edgar Award–winning true crime story that’s “stranger than fiction” (<i>The New York Times</i>)<i>.</i></b><br/><br/> From Joseph Wambaugh, the #1 <i>New York Times</i>–bestselling author of such classics as <i>The Onion Field </i>and <i>The Choirboys</i>, comes the extraordinary story of the chase for the “Pillow Pyro,” led by one ambitious firefighter.<br/><br/> Growing up in Los Angeles, John Orr idolized law enforcement. However, after being rejected by both the LAPD and LAFD, he settled for a position with the Glendale Fire Department. There, he rose through the ranks, eventually becoming a fire captain and one of Southern California’s best-known and most respected arson investigators. But Orr led another, unseen life, one that included womanizing and an insatiable thirst for recognition.<br/>  <br/> While Orr busted a slew of petty arsonists, there was one serial criminal he could not track down. Nothing was safe from the so-called Pillow Pyro’s obsession. Homes, retail stores, and fields of dry brush all went up in flames. His handiwork led to millions of dollars worth of property damage and the deaths of four innocent bystanders. But after years of evading the police, he made a mistake—one that would turn Orr’s life upside down.<br/>  <br/> The<i> Washington Post</i> raves, “When [Joseph Wambaugh] talks about the culture of cops versus the culture of firemen, we get no speculation, only hard-earned details.” Based on meticulous research, interviews, case records, and thousands of pages of court transcripts, <i>Fire Lover</i> is Wambaugh at his best.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Wambaugh
      </h2>
      
      <p class="authorDescription body article">The son of a policeman, Joseph Wambaugh (b. 1937) began his writing career while a member of the Los Angeles Police Department. He joined the LAPD in 1960 after three years in the Marine Corps, and rose to the rank of detective sergeant before retiring in 1974. His first novel, <i>The New Centurions</i> (1971), was a quick success, drawing praise for its realistic action and intelligent characterization, and was adapted into a feature film starring George C. Scott. He followed it up with <i>The Blue Knight</i> (1972), which was adapted into a mini-series starring William Holden and Lee Remick.&#160;Since then Wambaugh has continued writing about the LAPD. He has been credited with a realistic portrayal of police officers, showing them not as superheroes but as men struggling with a difficult job, a depiction taken mainstream by television&rsquo;s <i>Police Story</i>, which Wambaugh helped create in the mid-1970s. In addition to novels, Wambaugh has written nonfiction, winning a special Edgar Award for 1974&rsquo;s <i>The Onion Field</i>, an account of the longest criminal trial in California history. His most recent work is the novel <i>Hollywood Moon</i> (2010). <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0928f23c